export default `vec3 P=p, Q, b=vec3( 4.0, 2.8, 15.0 );
    float i, d=1., a;
    Q = mod( P, b ) - b * 0.5;
    d = P.z - 6.0;
    a = 1.3;
    for( int j = 0; j++ < 11; )
      d = min( d, length( max( abs( Q ) - b.zyy / 13.0, 0.0 ) ) / a ),
      Q = vec3( Q.y, abs( Q.x ) - 1.0, Q.z + 0.3 ) * 1.4,
      a *= 1.4;
    return d;
  }`